export default __webpack_public_path__ + "media/images/favicon-9df955ab58f5102b09c02c586391f917.svg";